import Link from "@tiptap/extension-link"

import { clickHandler } from "@productlane/lib/src/tiptap/extensions/link-extension/helpers/clickHandler"

import type { LinkOptions } from "@tiptap/extension-link"

const CustomLink = Link.extend<
	LinkOptions & { borderColor?: string; className?: string }
>({
	inclusive() {
		return false
	},

	addOptions() {
		return {
			...this.parent?.(),
			openOnClick: false,
			borderColor: "rgb(24,189,202)", // Default border color
			className: "",
		}
	},

	addProseMirrorPlugins() {
		return [...(this.parent?.() ?? []), clickHandler({ type: this.type })]
	},

	renderHTML({ HTMLAttributes }) {
		return [
			"a",
			{
				...HTMLAttributes,
				class: `cursor-pointer box-border border-b transition-all duration-75 ${this.options.className}`,
				style: `text-decoration: none; border-color: ${this.options.borderColor};`,
			},
			0,
		]
	},
})

export default CustomLink
